(function () {
  function initTextAnimations() {
    const blocks = document.querySelectorAll('.text-block--animate-in');

    if (!blocks.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const delay = parseFloat(entry.target.style.animationDelay) || 0;
            setTimeout(() => {
              entry.target.classList.add('is-visible');
            }, delay * 1000);
          } else {
            entry.target.classList.remove('is-visible');
          }
        });
      },
      { threshold: 0.15 }
    );

    blocks.forEach((block) => observer.observe(block));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTextAnimations);
  } else {
    initTextAnimations();
  }
})();
